import React from 'react';
import PropTypes from 'prop-types';
import Button from '@Components/Button';

function ExportModalFooter({ isFormAcceptable, apply }) {
  return (
    <div className="exportModal__footer">
      <Button
        type="button"
        disabled={!isFormAcceptable}
        onClick={apply}
        buttonConfig={{
          label: 'Export',
          type: 'primary',
          size: 'sm',
          e2eName: 'export-modal-apply',
          iconOnly: true,
        }}
        iconConfig={{
          name: 'chevron-right',
        }}
      />
    </div>
  );
}

ExportModalFooter.propTypes = {
  isFormAcceptable: PropTypes.bool,
  apply: PropTypes.func.isRequired,
};

export default ExportModalFooter;
